/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    className: 'll-mpf',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const pages = document.querySelectorAll( '.gform_page' ).length;
        if ( parseInt( currentPage ) === pages ) {
          $( '.ll-mpf-submit' ).removeClass( 'hidden' );

          $( '.ll-mpf-submit' ).on( 'click', function() {
            $( '.ll-submit' ).trigger( 'click' );
          } );
        } else {
          $( '.ll-mpf-submit' ).addClass( 'hidden' );
        }
        document.querySelectorAll( '.gform-skip-page' ).forEach( function( skipLink ) {
          skipLink.addEventListener( 'click', function( e ) {
            e.preventDefault();

            // Find the current form
            const form = skipLink.closest( 'form' );
            if ( !form ) return;

            // Trigger the "Next" button click
            const nextButton = form.querySelector( '.gform_page_footer input[type="button"].gform_next_button' );
            if ( nextButton ) {
              nextButton.click();
            }
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );

